import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';

import lazyload from './features/lazy-load';
import { presResult2022Mixin} from './vue/mixins/pres-result-2022';

lazyload();

const mixins = [presResult2022Mixin];
initMain(mixins, {
    PresElec2022Graph: () => import('./vue/components/pres-elec2022-graph/PresElec2022Graph.vue'),
}, []);
header();